/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ConversionTargetType {
  PDF = 'pdf',
  DOCX = 'docx',
  HTML = 'html',
  PODCAST = 'podcast',
}
